import { render, staticRenderFns } from "./Vote.vue?vue&type=template&id=b17d72d4&"
import script from "./Vote.vue?vue&type=script&lang=js&"
export * from "./Vote.vue?vue&type=script&lang=js&"
import style0 from "./Vote.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports